<template>
  <div class="coupon-center">
    <navbar show-home title="我的优惠券" />
    <van-tabs
      color="#FF3F2B"
      line-height="0.04rem"
      line-width="8%"
      offset-top="44"
      sticky
      title-active-color="#404040"
      title-inactive-color="#808080"
      v-model="current"
    >
      <van-tab :key="index" :title="tab" v-for="(tab, index) in tabs">
        <component :is="componentId" v-if="index === current"></component>
        <!-- <div class="tab-content" v-if="index== 0">
          <coupon-can-use />
        </div>
        <div class="tab-content" v-if="index== 1">
          <coupon-used />
        </div>
        <div class="tab-content" v-if="index== 2">
          <coupon-overdue />
        </div>-->
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Navbar from '../components/NavBar'
import { Tab, Tabs } from 'vant'
import CouponCanUse from '../components/couponCenter/CouponCanUse'
import CouponUsed from '../components/couponCenter/CouponUsed'
import CouponOverdue from '../components/couponCenter/CouponOverdue'
export default {
  name: 'coupon-center',
  components: {
    Navbar,
    VanTab: Tab,
    VanTabs: Tabs,
    CouponCanUse,
    CouponUsed,
    CouponOverdue
  },
  data () {
    return {
      current: 0,
      tabs: ['待使用', '已使用', '已过期'],
      componentId: null
    }
  },
  watch: {
    current (newVal) {
      switch (newVal) {
        case 0:
          this.componentId = CouponCanUse
          break
        case 1:
          this.componentId = CouponUsed
          break
        case 2:
          this.componentId = CouponOverdue
          break
      }
    }
  },
  created () {
    this.componentId = CouponCanUse
  }

}
</script>

<style lang="less" scoped>
.tab-content {
  padding: 0 0.2rem 0.24rem;
}
</style>
